<template>
  <div>
    <el-dialog :append-to-body="true" :visible.sync="dialogVisible" :width="element.options.customwidth" :title="element.options.title">
      <el-input v-if="element.options.isSearch" style="marginBottom:10px" placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
      <el-tree ref="LazyTree" v-if="!element.options.isLazy" :data="data" show-checkbox node-key="id" :check-strictly="true" :default-expand-all="element.options.isexpandall" :props="{label:element.options.displayField,children:element.options.childrenField}" :filter-node-method="filterNode">
      </el-tree>
      <!-- <el-tree ref="LazyTree" v-if="element.options.isLazy && element.options.dataForm ==0" show-checkbox node-key="id" :props="{label:element.options.displayField,children:element.options.childrenField}" lazy :check-strictly="true" :load="loadNode" :filter-node-method="filterNode">
      </el-tree> -->
      <!-- 同表懒加载 单描述 -->
      <el-tree ref="LazyTree" v-if="element.options.isLazy && element.options.dataForm ==0 && element.options.displayField.indexOf(',') == -1" show-checkbox node-key="id" :props="{label:element.options.displayField,children:element.options.childrenField}" lazy :check-strictly="true" :load="loadNode" :filter-node-method="filterNode">
      </el-tree>
      <!-- 同表懒加载 多描述 -->
      <el-tree ref="LazyTree" v-if="element.options.isLazy && element.options.dataForm ==0 && element.options.displayField.indexOf(',') !== -1" show-checkbox node-key="id" lazy :check-strictly="true" :load="loadNode" :filter-node-method="filterNode">
          <span slot-scope="{ node, data }">
              <span v-for="(labelItem,labelIndex) in element.options.displayField.split(',')" :key="labelIndex"><i :class='data.iconClass' v-if="labelIndex == 0"></i>{{ data[labelItem] }}&nbsp;&nbsp;</span>
          </span>
      </el-tree>
      <el-tree ref="LazyTree" v-if="element.options.isLazy && element.options.dataForm ==1" show-checkbox node-key="id" :props="{label:element.options.displayField,children:element.options.childrenField}" lazy :check-strictly="true" :load="loadNode2" :filter-node-method="filterNode">
      </el-tree>
      <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="dialogVisible = false">取 消</el-button>
                <el-button size="mini" type="primary" @click="defineBtn">确 定</el-button>
            </span>
    </el-dialog>
  </div>
</template>

<script>
  
  export default {
    name: 'treePopupComponents',
    props: ['element','isChild','isChildList','currentListchildData'],
    data(){
      return{
        basic_url: Config.dev_url,
        dialogVisible: false,
        item:{}, //当前弹出框的配置信息
        noLazyprops:'',
        data:[],
        resourceData:[],
        filterText: '',
      }
    },
    watch: {
      filterText(val) {
        this.$refs.LazyTree.filter(val);
      }
    },
    computed:{
      detailInfos(){
        return this.$store.state.detailInfo
      },
      //子表信息
      currentAppChildRowData(){
        return this.$store.state.currentAppChildRowData
      },
    },
    methods:{
      filterNode(value, data) {
        if (!value) return true;
        var arr = this.element.options.displayField.split(',')
        return arr.some((item)=>{
            return data[item].indexOf(value) !== -1;
        })
        // return data[this.element.options.displayField].indexOf(value) !== -1;
      },
      async loadNode(node, resolve) {
        if(this.item.options.isLazy && this.item.options.dataForm == 0){
          console.log(node)
          if (node.level === 0) {
            this.resourceData = await this.getParentData(this.item);
            return resolve(this.resourceData);
          }
          if(node.level != 0){
            this.getChildrenLastNode1(node.data,resolve)
          }
        }
      },
      async loadNode2(node, resolve) {
        if(this.item.options.isLazy && this.item.options.dataForm == 1){
          console.log(node,this.item)
          if (node.level === 0) {
            this.resourceData = await this.getParentData(this.item,node);
            return resolve(this.resourceData);
          }
          if(this.item.options.childUrlList.length !==0){
            var val = this.item.options.childUrlList.every((item)=>{
              return item.hierarchy < node.level
            })
            console.log(val)
            if(val){
              resolve([])
            }else{
              for(var i=0; i<this.item.options.childUrlList.length;i++){
                if(this.item.options.childUrlList[i].hierarchy == node.level){
                  this.getChildrenLastNode2(this.item,this.item.options.childUrlList[i],node.data,resolve)
                }
              }
            }
          }
        }
      },
      //不同表获取子级数据
      getChildrenLastNode2(item,childitem,node,resolve){
        var url = childitem.url
        var method = childitem.methods
        var data = {}
        if(url.indexOf('+p:') !== -1){
          url = url.replace(url.substr(url.indexOf('+p:'),url.length),node[url.substr(url.indexOf('+p:')+3,url.length)])
          var requestUrl = Config.dev_url + url
        }else if(url.indexOf('+m:') !== -1){
          if(this.isChild){
            url = url.replace(url.substr(url.indexOf('+m:'),url.length),this.currentAppChildRowData[url.substr(url.indexOf('+m:')+3,url.length)])
          }else{
            url = url.replace(url.substr(url.indexOf('+m:'),url.length),this.detailInfos[url.substr(url.indexOf('+m:')+3,url.length)])
          }
          var requestUrl = Config.dev_url + url
        }else if(url.indexOf('?') !== -1){
          var params = url.substr(url.indexOf('?')+1,url.length)
          var paramsList = params.split('&')
          for(var i=0; i<paramsList.length; i++){
            if(paramsList[i].indexOf('m:') !== -1){
              if(this.isChild){
                paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.currentAppChildRowData[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
              }else{
                paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.detailInfos[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
              }
            }
            if(paramsList[i].indexOf('p:') !== -1){
              paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('p:'),paramsList[i].length),node[paramsList[i].substr(paramsList[i].indexOf('p:')+2,paramsList[i].length)])
            }
            data[paramsList[i].substr(0,paramsList[i].indexOf('='))] = paramsList[i].substr(paramsList[i].indexOf('=')+1,paramsList[i].length)
          }
          if(method == 'get'){
            var paramsStr = '?' + paramsList.join("&")
            var requestUrl = Config.dev_url + url.substr(0,url.indexOf('?')) + paramsStr
            data = {}
          }else{
            var requestUrl = Config.dev_url + url.substr(0,url.indexOf('?'))
          }
        }else{
          var requestUrl = Config.dev_url + childitem.url
        }
        this.$axios[method](requestUrl,data).then((res)=>{
          console.log(res,"二级数据不同表")
          var resultData = res.data.data || res.data.datas || res.data
          this.resourceData = resultData;
          if(childitem.displayField !== item.options.displayField){
            if(res.data.length !== 0){
              for(var i=0; i<resultData.length; i++){
                var childData = resultData[i]
                childData[item.options.displayField] = childData[childitem.displayField]
              }
            }
          }
          resolve(resultData);
        }).catch((err) => {
        });
      },
      view(item){
        this.item = item
        this.dialogVisible = true
        this.$nextTick(()=>{
          this.$refs.LazyTree.setCheckedKeys([]);
        })
        this.getData(item)
      },
      //同表获取子级数据
      getChildrenLastNode1(node,resolve){
        var url = this.item.options.childurl
        var method = this.item.options.childmethods
        var data = {}
        if(url.indexOf('?') !== -1){
          var params = url.substr(url.indexOf('?')+1,url.length)
          var paramsList = params.split('&')
          for(var i=0; i<paramsList.length; i++){
            if(paramsList[i].indexOf('m:') !== -1){
              if(this.isChild){
                paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.currentAppChildRowData[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
              }else{
                paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.detailInfos[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
              }
            }
            if(paramsList[i].indexOf('p:') !== -1){
              paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('p:'),paramsList[i].length),node[paramsList[i].substr(paramsList[i].indexOf('p:')+2,paramsList[i].length)])
            }
            data[paramsList[i].substr(0,paramsList[i].indexOf('='))] = paramsList[i].substr(paramsList[i].indexOf('=')+1,paramsList[i].length)
          }
          if(method == 'get'){
            var paramsStr = '?' + paramsList.join("&")
            var requestUrl = Config.dev_url + url.substr(0,url.indexOf('?')) + paramsStr
            data = {}
          }else{
            var requestUrl = Config.dev_url + url.substr(0,url.indexOf('?'))
          }
        }else{
          var requestUrl = Config.dev_url + this.item.options.childurl
        }
        this.$axios[method](requestUrl,data).then((res)=>{
          console.log(res,"二级数据同表")
          var resultData = res.data.data || res.data.datas || res.data
          this.resourceData = resultData;
          resolve(resultData);

        }).catch((err) => {
        });
      },
      //获取懒加载的父级数据
      getParentData(item){
        var url = item.options.parenturl
        var method = item.options.methods;
        var data = {}
        if(url.indexOf('?') !== -1){  //参数存在
          var params = url.substr(url.indexOf('?')+1,url.length)
          var paramsList = params.split('&')
          for(var i=0; i<paramsList.length; i++){
            if(paramsList[i].indexOf('m:') !== -1){
              if(this.isChild){
                paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.currentAppChildRowData[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
              }else{
                paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.detailInfos[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
              }
            }
            data[paramsList[i].substr(0,paramsList[i].indexOf('='))] = paramsList[i].substr(paramsList[i].indexOf('=')+1,paramsList[i].length)
          }
          if(method == 'get'){
            var paramsStr = '?' + paramsList.join("&")
            var requestUrl = Config.dev_url + url.substr(0,url.indexOf('?')) + paramsStr
            data = {}
          }else{
            var requestUrl = Config.dev_url + url.substr(0,url.indexOf('?'))
          }
        }else{
          var requestUrl = Config.dev_url + item.options.parenturl
        }
        let that = this;
        return new Promise(function(resolve,reject){
          that.$axios[method](requestUrl,data).then((res)=>{
            var resultData = res.data.data || res.data.datas || res.data
            console.log(resultData,item)
            resolve(resultData);
            that.resourceData = resultData;
          }).catch((err) => {
          });
        })
      },
      //非懒加载获取数据
      getData(item){
        console.log(item)
        if(!item.options.isLazy){   //懒加载
          //处理查询条件
          var noLazyUrl = item.options.url
          var noLazyMethod = item.options.methods;
          var noLazyData = {}
          if(noLazyUrl.indexOf('?') !== -1){   //参数存在
            var params = noLazyUrl.substr(noLazyUrl.indexOf('?')+1,noLazyUrl.length)
            var paramsList = params.split('&')
            for(var i=0; i<paramsList.length; i++){
              if(paramsList[i].indexOf('m:') !== -1){
                if(this.isChild){
                  paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.currentAppChildRowData[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
                }else{
                  paramsList[i] = paramsList[i].replace(paramsList[i].substr(paramsList[i].indexOf('m:'),paramsList[i].length),this.detailInfos[paramsList[i].substr(paramsList[i].indexOf('m:')+2,paramsList[i].length)])
                }
              }
              noLazyData[paramsList[i].substr(0,paramsList[i].indexOf('='))] = paramsList[i].substr(paramsList[i].indexOf('=')+1,paramsList[i].length)
            }
            if(noLazyMethod == 'get'){
              var paramsStr = '?' + paramsList.join("&")
              var requestUrl = Config.dev_url + noLazyUrl.substr(0,noLazyUrl.indexOf('?')) + paramsStr
              noLazyData = {}
            }else{
              var requestUrl = Config.dev_url + noLazyUrl.substr(0,url.indexOf('?'))
            }
          }else{
            var requestUrl = Config.dev_url + noLazyUrl
          }
          this.$axios[noLazyMethod](requestUrl,noLazyData).then((res)=>{
            this.data = res.data
          }).catch((err) => {
          });
        }
      },
      //确定按钮点击
      defineBtn(){
        var selectDataList = this.$refs.LazyTree.getCheckedNodes()
        if(selectDataList.length == 0){
          this.$message.warning('请先选择数据再进行操作');
          return;
        }else if(selectDataList.length > 1){
          this.$message.warning('最多只能选择一条数据');
          return;
        }else{
          var selectData = selectDataList[0]
          console.log(selectData)
          var assignmentConfigList = this.element.options.assignmentConfigList;
          for (var i = 0; i < assignmentConfigList.length; i++) {
            if (!!assignmentConfigList[i].replaceField && !!assignmentConfigList[i].displayField) {
              if (this.isChild) {
                if(this.isChildList){
                    this.$set(this.currentListchildData,assignmentConfigList[i].replaceField,selectData[assignmentConfigList[i].displayField])
                }else{
                    this.$set(this.currentAppChildRowData,assignmentConfigList[i].replaceField,selectData[assignmentConfigList[i].displayField])
                }
              } else {
                this.$set(this.detailInfos,assignmentConfigList[i].replaceField,selectData[assignmentConfigList[i].displayField])
              }
            }
          }
          this.$emit("updateChooseTree");
          this.dialogVisible = false;
        }
      }
    }
  }
</script>

<style>

</style>
